import { IPairKey } from '@/store/models/encryption.model';
import { IBaseAction, IBaseState, TAppError } from '@/store/types/base.state';

export enum EncryptionActionTypes {
  FETCH_GLOBAL_SUPPORT_PUBLIC_KEY = 'ENCRYPTION.FETCH_GLOBAL_SUPPORT_PUBLIC_KEY',
  FETCH_GLOBAL_SUPPORT_PUBLIC_KEY_SUCCESS = 'ENCRYPTION.FETCH_GLOBAL_SUPPORT_PUBLIC_KEY_SUCCESS',
  FETCH_GLOBAL_SUPPORT_PUBLIC_KEY_FAIL = 'ENCRYPTION.FETCH_GLOBAL_SUPPORT_PUBLIC_KEY_FAIL',

  SET_GLOBAL_SUPPORT_PUBLIC_KEY = 'ENCRYPTION.SET_GLOBAL_SUPPORT_PUBLIC_KEY',
  SET_GLOBAL_SUPPORT_PUBLIC_KEY_SUCCESS = 'ENCRYPTION.SET_GLOBAL_SUPPORT_PUBLIC_KEY_SUCCESS',
  SET_GLOBAL_SUPPORT_PUBLIC_KEY_FAIL = 'ENCRYPTION.SET_GLOBAL_SUPPORT_PUBLIC_KEY_FAIL',

  FETCH_SUPPORT_USER_ENCRYPTED_KEY = 'ENCRYPTION.FETCH_SUPPORT_USER_ENCRYPTED_KEY',
  FETCH_SUPPORT_USER_ENCRYPTED_KEY_SUCCESS = 'ENCRYPTION.FETCH_SUPPORT_USER_ENCRYPTED_KEY_SUCCESS',
  FETCH_SUPPORT_USER_ENCRYPTED_KEY_FAIL = 'ENCRYPTION.FETCH_SUPPORT_USER_ENCRYPTED_KEY_FAIL',

  FETCH_USER_DECRYPTED_KEY = 'ENCRYPTION.FETCH_USER_DECRYPTED_KEY',
  FETCH_USER_DECRYPTED_KEY_SUCCESS = 'ENCRYPTION.FETCH_USER_DECRYPTED_KEY_SUCCESS',
  FETCH_USER_DECRYPTED_KEY_FAIL = 'ENCRYPTION.FETCH_USER_DECRYPTED_KEY_FAIL',

  SET_GLOBAL_SUPPORT_PAIR_KEY = 'ENCRYPTION.SET_GLOBAL_SUPPORT_PAIR_KEY',
  SET_SUPPORT_USER_PAIR_KEY = 'ENCRYPTION.SET_SUPPORT_USER_PAIR_KEY',
  ADD_USER_PAIR_KEY = 'ENCRYPTION.ADD_USER_PAIR_KEY',
}

export interface IFetchGlobalSupportPublicKeyAction extends IBaseAction {
  type: typeof EncryptionActionTypes.FETCH_GLOBAL_SUPPORT_PUBLIC_KEY;
}

export interface IFetchGlobalSupportPublicKeySuccessAction extends IBaseAction {
  type: typeof EncryptionActionTypes.FETCH_GLOBAL_SUPPORT_PUBLIC_KEY_SUCCESS;
  globalSupportPublicKey: string;
}

export interface IFetchGlobalSupportPublicKeyFailAction extends IBaseAction {
  type: typeof EncryptionActionTypes.FETCH_GLOBAL_SUPPORT_PUBLIC_KEY_FAIL;
  error: TAppError;
}

export interface ISetGlobalSupportPublicKeyAction extends IBaseAction {
  type: typeof EncryptionActionTypes.SET_GLOBAL_SUPPORT_PUBLIC_KEY;
}

export interface ISetGlobalSupportPublicKeySuccessAction extends IBaseAction {
  type: typeof EncryptionActionTypes.SET_GLOBAL_SUPPORT_PUBLIC_KEY_SUCCESS;
  globalSupportPublicKey: string;
}

export interface ISetGlobalSupportPublicKeyFailAction extends IBaseAction {
  type: typeof EncryptionActionTypes.SET_GLOBAL_SUPPORT_PUBLIC_KEY_FAIL;
  error: TAppError;
}

export interface IFetchSupportUserEncryptedKeyAction extends IBaseAction {
  type: typeof EncryptionActionTypes.FETCH_SUPPORT_USER_ENCRYPTED_KEY;
}

export interface IFetchSupportUserEncryptedKeySuccessAction extends IBaseAction {
  type: typeof EncryptionActionTypes.FETCH_SUPPORT_USER_ENCRYPTED_KEY_SUCCESS;
  supportUserPairKey: IPairKey;
}

export interface IFetchSupportUserEncryptedKeyFailAction extends IBaseAction {
  type: typeof EncryptionActionTypes.FETCH_SUPPORT_USER_ENCRYPTED_KEY_FAIL;
  error: TAppError;
}

export interface IFetchUserDecryptedKeyAction extends IBaseAction {
  type: typeof EncryptionActionTypes.FETCH_USER_DECRYPTED_KEY;
}

export interface IFetchUserDecryptedKeySuccessAction extends IBaseAction {
  type: typeof EncryptionActionTypes.FETCH_USER_DECRYPTED_KEY_SUCCESS;
  userId: number;
  userPairKey: IPairKey;
}

export interface IFetchUserDecryptedKeyFailAction extends IBaseAction {
  type: typeof EncryptionActionTypes.FETCH_USER_DECRYPTED_KEY_FAIL;
  error: TAppError;
}

export interface IAddUserPairKeyAction extends IBaseAction {
  type: typeof EncryptionActionTypes.ADD_USER_PAIR_KEY;
  userId: number;
  userPairKey: IPairKey;
}

export interface ISetSupportUserPairKeyAction extends IBaseAction {
  type: typeof EncryptionActionTypes.SET_SUPPORT_USER_PAIR_KEY;
  supportUserPairKey: IPairKey;
}

export interface ISetGlobalSupportUserPairKeyAction extends IBaseAction {
  type: typeof EncryptionActionTypes.SET_GLOBAL_SUPPORT_PAIR_KEY;
  globalSupportPairKey: IPairKey;
}

export type TCryptoAction =
  | IFetchGlobalSupportPublicKeyAction
  | IFetchGlobalSupportPublicKeySuccessAction
  | IFetchGlobalSupportPublicKeyFailAction
  | ISetGlobalSupportPublicKeyAction
  | ISetGlobalSupportPublicKeySuccessAction
  | ISetGlobalSupportPublicKeyFailAction
  | IFetchSupportUserEncryptedKeyAction
  | IFetchSupportUserEncryptedKeySuccessAction
  | IFetchSupportUserEncryptedKeyFailAction
  | IFetchUserDecryptedKeyAction
  | IFetchUserDecryptedKeySuccessAction
  | IFetchUserDecryptedKeyFailAction
  | IAddUserPairKeyAction
  | ISetSupportUserPairKeyAction
  | ISetGlobalSupportUserPairKeyAction;

export interface ICryptoState extends IBaseState {
  supportUserPairKey?: IPairKey;
  globalSupportPairKey?: IPairKey;
  endUsersKeyPair: Record<string, IPairKey>;
}
